import graphql__cd01aa1b5442378aa5bc from "./__generated__/FeaturedContentBlockText_block.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import classNames from "classnames";

import ButtonLink from "../Buttons/ButtonLink";
import { hasHtmlContent, cleanHtml } from "../Utils/htmlStringUtils";
import Icon from "../Utils/Icon";

const FeaturedContentBlockText = props => {
  const { url, image, title, description } = props.block;

  const hasTitle = hasHtmlContent(title);

  const titleNode = hasTitle && <div className="text-btn-sm">{title}</div>;

  // Add a small margin between title and description, when both are present
  const descriptionClassName = classNames(["text-small", { "margin-top-xxs": hasTitle }]);

  const descriptionNode = hasHtmlContent(description) && (
    <div
      className={descriptionClassName}
      dangerouslySetInnerHTML={{ __html: cleanHtml(description) }}
    />
  );

  return (
    <ButtonLink
      href={url}
      className="btn btn-primary-inverse btn-block-md box-shadow h-100 d-flex align-items-center position-relative"
    >
      {image && (
        <img
          src={image.url}
          className="rounded-circle margin-right-sm"
          alt={image.altText}
        />
      )}

      <div className="flex-1">
        {titleNode}
        {descriptionNode}
      </div>

      <Icon className="btn-bottom-right-arrow icon-arrow-right-circle float-right margin-top-xs text-primary" />
    </ButtonLink>
  );
};

export default createFragmentContainer(FeaturedContentBlockText, {
  block: graphql__cd01aa1b5442378aa5bc
});
